<template>
	<div class="container ">
		<img class="login_1" src="https://api.ezlunch.club/pc/image/1.png" alt="" srcset="">
		<div class="w1200 flex fixed login_2">
			<div class="flex benben-flex-layout flex-wrap align-center pointer" @click="caozuo()">
				<img class="bind_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
				<div class="bind_1_2">{{$t('返回')}}</div>
			</div>
			<div class="flex benben-flex-layout flex-wrap align-center pointer login_2_1 " @click="huan">
				<img class="login_2_11" src="https://api.ezlunch.club/pc/image/2.png" alt="" srcset="">
			    <div class="">{{ $t('语言切换') }}</div>
			</div>
		</div>
		<div class="flex flex-direction flex-wrap align-center benben-flex-layout w1200 absolute login_3">
			<div class="relative login_4">
				<img class="relative login_4_1" src="https://api.ezlunch.club/pc/image/3.png" alt="" srcset="">
				<div class="absolute login_4_2"></div>
			</div>
			<div class="login_5">
				<div v-if="!wang_type" class="flex relative login_14">
					<div class="flex flex benben-flex-layout flex-wrap align-center pointer " @click="qiehuan(7)">
						<img class="login_14_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
						<div class="login_14_2">{{$t('返回')}}</div>
					</div>
					<div class="absolute login_14_3">{{$t('忘记密码')}}</div>
				</div>
				<div class="login_6 flex" v-if="zhu_type && wang_type">
					<div class="login_6_1 flex flex-direction flex-wrap align-center benben-flex-layout">
						<div @click="qiehuan(1)" class="pointer" :class="deng_type == 1 ? 'login_6_3' : 'login_6_3s'">{{$t('手机号登录')}}</div>
						<div :class="deng_type == 1 ? 'login_6_2' : 'login_6_2s'"></div>
					</div>
					<div class="login_6_1 flex flex-direction flex-wrap align-center benben-flex-layout">
						<div @click="qiehuan(2)" class="pointer" :class="deng_type == 2 ? 'login_6_3' : 'login_6_3s'">{{$t('邮箱号登录')}}</div>
						<div :class="deng_type == 2 ? 'login_6_2' : 'login_6_2s'"></div>
					</div>
				</div>
				<div class="login_6 flex" v-if="!zhu_type && wang_type">
					<div class="login_6_1 flex flex-direction flex-wrap align-center benben-flex-layout">
						<div @click="qiehuan(4)" class="pointer" :class="ce_type == 1 ? 'login_6_3' : 'login_6_3s'">{{$t('手机号注册')}}</div>
						<div :class="ce_type == 1 ? 'login_6_2' : 'login_6_2s'"></div>
					</div>
					<div class="login_6_1 flex flex-direction flex-wrap align-center benben-flex-layout">
						<div @click="qiehuan(4)" class="pointer" :class="ce_type == 2 ? 'login_6_3' : 'login_6_3s'">{{$t('邮箱号注册')}}</div>
						<div :class="ce_type == 2 ? 'login_6_2' : 'login_6_2s'"></div>
					</div>
				</div>
				<div class="login_6 flex" v-if="!wang_type">
					<div class="login_6_1 flex flex-direction flex-wrap align-center benben-flex-layout">
						<div @click="qiehuan(6)" class="pointer" :class="zhao_type == 1 ? 'login_6_3' : 'login_6_3s'">{{$t('手机号找回')}}</div>
						<div :class="zhao_type == 1 ? 'login_6_2' : 'login_6_2s'"></div>
					</div>
					<div class="login_6_1 flex flex-direction flex-wrap align-center benben-flex-layout">
						<div @click="qiehuan(6)" class="pointer" :class="zhao_type == 2 ? 'login_6_3' : 'login_6_3s'">{{$t('邮箱号找回')}}</div>
						<div :class="zhao_type == 2 ? 'login_6_2' : 'login_6_2s'"></div>
					</div>
				</div>
				
				<div class="flex benben-flex-layout flex-wrap align-center login_7" v-if="(zhu_type && wang_type && deng_type == 1) || (!zhu_type && wang_type && ce_type == 1) || (!wang_type && zhao_type == 1)">
					<img class="login_7_1" src="https://api.ezlunch.club/pc/image/4.png" alt="" srcset="">
					<el-select class="elSelect" v-model="qu_id" :placeholder="$t('请选择')">
					    <el-option
					      v-for="item in qu_list"
					      :key="item.value"
					      :label="item.label"
					      :value="item.value">
					    </el-option>
					  </el-select>
					<!-- <div class="flex benben-flex-layout flex-wrap align-center pointer">
						<div class="login_7_2">+1</div>
						<img class="login_7_3" src="https://api.ezlunch.club/pc/image/8.png" alt="" srcset="">
					</div> -->
					 <el-input class="flex-sub" v-model="phone"  type='number' :placeholder="$t('请输入手机号')"></el-input>
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center login_7" v-if="(zhu_type && wang_type && deng_type == 2) || (!zhu_type && wang_type && ce_type == 2) || (!wang_type && zhao_type == 2)">
					<img class="login_7_1" src="https://api.ezlunch.club/pc/image/11.png" alt="" srcset="">
					 <el-input class="flex-sub" v-model="email" :placeholder="$t('请输入邮箱号')"></el-input>
				</div>
				
				<div class="flex benben-flex-layout flex-wrap align-center login_7" v-if="!paw_type || !zhu_type || !wang_type">
					<img class="login_7_1" src="https://api.ezlunch.club/pc/image/12.png" alt="" srcset="">
					<el-input class="flex-sub" v-model="code"  type='number' :placeholder="$t('请输入验证码')"></el-input>
				    <div class="login_53 pointer">
						
				    	<div @click="tioCod" v-if="!timTpe">{{$t('获取验证码')}}</div>
				    	<div v-else>{{time}}{{$t('秒后重新获取')}}</div>
				    </div>
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center login_7" v-if="paw_type || !zhu_type || !wang_type">
					<img class="login_7_1" src="https://api.ezlunch.club/pc/image/5.png" alt="" srcset="">
					<el-input class="flex-sub" ref="pwdInput" :type="pwdObj.pwdType" v-model="password" :placeholder="$t('请输入密码')"
						@focus="focusEnd($event)">
					</el-input>
					<img slot="suffix" class="login_7_4" :src="pwdObj.pwdType === 'text' ? img2 : img1 "
					    fit="scale-down" @click="changeye('pwdType','pwdInput')">
				</div>
				<div class="flex flex-direction align-end login_8" v-if="zhu_type && wang_type">
					<div class="login_8_1 pointer" @click="qiehuan(3)" v-if="paw_type">{{$t('验证码登录')}}</div>
					<div class="login_8_1 pointer" @click="qiehuan(3)" v-else>{{$t('密码登录')}}</div>
				</div>
				<div class="login_9 pointer" v-if="zhu_type && wang_type" @click="tijiao(paw_type ? '1':'2')">{{$t('登录')}}</div>
				<div class="login_9 pointer" v-if="!zhu_type && wang_type" @click="tijiao(4)">{{$t('注册')}}</div>
				<div class="login_9 pointer" v-if="!wang_type" @click="tijiao(3)">{{$t('确定')}}</div>
				<div class="flex justify-between login_10" v-if="zhu_type && wang_type">
					<div class="login_8_1 pointer" @click="qiehuan(7)">{{$t('忘记密码')}}</div>
					<div class="login_8_1 pointer" @click="qiehuan(5)">{{$t('注册')}}</div>
				</div>
				<div class="flex  align-center justify-center benben-flex-layout login_12" v-if="!zhu_type">
					<div class="flex flex-wrap login_11_2">
						<div>{{$t('已有账号，前去')}}</div>
						<div class="pointer login_13" @click="qiehuan(5)">登录</div>
					</div>
				</div>
				<div class="flex  align-center justify-center benben-flex-layout login_11" v-if="wang_type">
					<div class="pointer" @click="xie_type = !xie_type">
						<img v-if="!xie_type" class="login_11_1" src="https://api.ezlunch.club/pc/image/9.png" alt="" srcset="">
						<img v-else class="login_11_1" src="https://api.ezlunch.club/pc/image/10.png" alt="" srcset="">
					</div>
					<div class="flex flex-wrap login_11_2">
						<div>{{$t('已阅读并同意')}}</div>
						<div class="pointer" @click="drawer1 = true">《{{$t('用户注册协议')}}》</div>
						<div>{{$t('与')}}</div>
						<div class="pointer" @click="drawer2 = true">《{{$t('隐私政策')}}》</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="$t('用户注册协议')" :visible.sync="drawer1" width="1200px">
			<div class="index8">
				<div class="content-h" v-html="detail1.content"></div>
			</div>
		</el-dialog>
		<el-dialog :title="$t('隐私政策')" :visible.sync="drawer2" width="1200px">
			<div class="index8">
				<div class="content-h" v-html="detail2.content"></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import CryptoJS from '../api/crypto-js.min.js'
	export default {
		components: {},
		data() {
			return {
				qu_list:[
					{
					    value: '1',
					    label: '美国（+1）'
					},
					{
					    value: '86',
					    label: '中国（+86）'
					},
				],
				qu_id:'1',
				time:60,
				timTpe: false,
				td: '',
				detail1:{
					content:''
				},
				detail2:{
					content:''
				},
				drawer1:false,
				drawer2:false,
				deng_type:1, // 手机号邮箱
				paw_type:true, // 验证码密码
				xie_type:false, //协议
				zhu_type:true,//注册
				ce_type:1,// 手机号邮箱
				wang_type:true,// 忘记密码
				zhao_type:1,// 手机号邮箱
				phone_list: [
					{
				        value: '1',
				        label: '+1'
				    },
				],
				phone_id: '1',
				img1: 'https://api.ezlunch.club/pc/image/6.png',
				img2: 'https://api.ezlunch.club/pc/image/7.png',
				pwdObj: {
					pwdType: 'password'
				},
				phone:'',
				email:'',
				password:'',
				code:'',
				post_type:false,
				ti_type:false,
			}
		},
		created() {
			this.post641568f1b6f871()
			this.post641568f1b6f872()
		},

		methods: {
			caozuo(){
				// zhushen123
				// 15652366680
				this.$router.push({
					name: 'menu',
				});
			},
			gengxin(){
				
			},
			post641568f1b6f871(){
				this.$api.get(this.$apiUrls.post641568f1b6f87,{params: {column_id: 19}}).then((res) => {
					if(res.code == 1){
						this.detail1 = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			post641568f1b6f872(){
				this.$api.get(this.$apiUrls.post641568f1b6f87,{params: {column_id: 19}}).then((res) => {
					if(res.code == 1){
						this.detail2 = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 获取验证码
			tioCod() {
				
				if(!this.paw_type && this.zhu_type && this.wang_type){ // 验证码登录
					if(this.deng_type == 1){
						if (!this.phone) {
							this.$message.error(this.$t('请输入手机号'));
							return
						}
					}else if(this.deng_type == 2){
						if (!this.email) {
							this.$message.error(this.$t('请输入邮箱号'));
							return
						}
					}
				}else if(!this.zhu_type && this.paw_type && this.wang_type){ // 注册
					if(this.ce_type == 1){
						if (!this.phone) {
							this.$message.error(this.$t('请输入手机号'));
							return
						}
					}else if(this.ce_type == 2){
						if (!this.email) {
							this.$message.error(this.$t('请输入邮箱号'));
							return
						}
					}
				}else if(!this.wang_type && this.paw_type && this.zhu_type){ // 忘记密码
					if(this.zhao_type == 1){
						if (!this.phone) {
							this.$message.error(this.$t('请输入手机号'));
							return
						}
					}else if(this.zhao_type == 2){
						if (!this.email) {
							this.$message.error(this.$t('请输入邮箱号'));
							return
						}
					}
				}
				
				if (this.post_type) {
					return
				}
				this.post_type = true
				
				this.$api.post(this.$apiUrls.post6668f5d1d434e,{
					captcha_data: this.getCaptchaData()
				}).then((res)=> {
					if (res.code == 1) {
						this.post666a45d4d6bb4(res.data.captcha_key)
					} else {
						this.post_type = false
					}
				})
			},
			post666a45d4d6bb4(key){
				let page = {
					is_test: 1,
					captcha_data: this.getCaptchaData(),
					captcha_key: key,
				}
				if(!this.paw_type && this.zhu_type && this.wang_type){ // 验证码登录
					page.type = 3
					if(this.deng_type == 1){
						page.mobile = this.phone
						page.accountType = 'phone'
						page.area_code = this.qu_id
					}else if(this.deng_type == 2){
						page.user_email = this.email
						page.accountType = 'email'
					}
				}else if(!this.zhu_type && this.paw_type && this.wang_type){ // 注册
					page.type = 1
					if(this.ce_type == 1){
						page.mobile = this.phone
						page.accountType = 'phone'
						page.area_code = this.qu_id
					}else if(this.ce_type == 2){
						page.user_email = this.email
						page.accountType = 'email'
					}
				}else if(!this.wang_type && this.paw_type && this.zhu_type){ // 忘记密码
					page.type = 2
					
					if(this.zhao_type == 1){
						page.mobile = this.phone
						page.accountType = 'phone'
						page.area_code = this.qu_id
					}else if(this.zhao_type == 2){
						page.user_email = this.email
						page.accountType = 'email'
					}
				}
				
				
				this.$api.post(this.$apiUrls.post666a45d4d6bb4, page).then((res) => {
					if (res.code == 1) {
						if (res.data.code) {
							this.$message.success(res.data.code);
						} else {
							this.$message.success('发送成功！');
						}
						let that = this
						this.td = setInterval(function() {
							// console.log(that.time ,'执行')
							// 判断剩余秒数
							if (that.time == 0) {
								// 清除定时器和复原按钮
								that.timTpe = false
								clearInterval(that.td);
							} else {
								that.timTpe = true
								that.time--;
							}
						}, 1000);
						this.post_type = false
					} else {
						this.post_type = false
					}
				})
			},
			// 确定登录
			tijiao(type){
				console.log(type,11111111)
				let url = ''
				let page = {}
				if(type == 1){// 账号密码登录
					if(this.deng_type == 1){
						if (!this.phone) {
							this.$message.error(this.$t('请输入手机号'));
							return
						}
						page.account_type = 'mobile'
						page.area_code = this.qu_id
						page.account = this.phone
					}else if(this.deng_type == 2){
						if (!this.email) {
							this.$message.error(this.$t('请输入邮箱号'));
							return
						}
						page.account_type = 'email'
						page.account = this.email
					}
					if (!this.password) {
						this.$message.error(this.$t('请输入密码'));
						return
					}
					page.password = this.password
					url = this.$apiUrls.post5c78dbfd977cf
				}else if(type == 2){// 验证码登录
					if(this.deng_type == 1){
						if (!this.phone) {
							this.$message.error(this.$t('请输入手机号'));
							return
						}
						page.area_code = this.qu_id
						page.mobile = this.phone
					}else if(this.deng_type == 2){
						if (!this.email) {
							this.$message.error(this.$t('请输入邮箱号'));
							return
						}
						page.email = this.email
					}
					if(!this.code){
						this.$message.error(this.$t('请输入验证码'));
						return
					}
					page.code = this.code
					page.type = 3
					url = this.$apiUrls.post5c78dca45ebc1
				}else if(type == 3){// 忘记密码
					if(this.zhao_type == 1){
						if (!this.phone) {
							this.$message.error(this.$t('请输入手机号'));
							return
						}
						page.area_code = this.qu_id
						page.account = this.phone
						page.account_type = 'mobile'
					}else if(this.zhao_type == 2){
						if (!this.email) {
							this.$message.error(this.$t('请输入邮箱号'));
							return
						}
						page.account = this.email
						page.account_type = 'email'
					}
					if(!this.code){
						this.$message.error(this.$t('请输入验证码'));
						return
					}
					if (!this.password) {
						this.$message.error(this.$t('请输入密码'));
						return
					}
					page.code = this.code
					page.password = this.password
					
					url = this.$apiUrls.post5caeeba9866aa
				}else if(type == 4){ // 注册
					page.type = 1
					if(this.ce_type == 1){
						if (!this.phone) {
							this.$message.error(this.$t('请输入手机号'));
							return
						}
						page.mobile = this.phone
						page.area_code = this.qu_id
					}else if(this.ce_type == 2){
						if (!this.email) {
							this.$message.error(this.$t('请输入邮箱号'));
							return
						}
						page.email = this.email
					}
					if(!this.code){
						this.$message.error(this.$t('请输入验证码'));
						return
					}
					if (!this.password) {
						this.$message.error(this.$t('请输入密码'));
						return
					}
					page.password = this.password
					page.code = this.code
					url = this.$apiUrls.post5cad9f63e4f94
					
				}
			    if(type != 3 && !this.xie_type){
			    	this.$message.error(this.$t('请勾选协议'));
			    	return
			    }
				if(this.ti_type){
					return
				}
				this.ti_type = true
				this.$api.post(url, page).then((res) => {
					if(res.code == 1){
						if(type == 2 || type == 1){ // 密码 验证码登录
							window.sessionStorage.setItem('token', res.data.userinfo.user_token);
							window.sessionStorage.setItem('user',JSON.stringify(res.data.userinfo));
							window.sessionStorage.setItem('statusType', 1);
							this.$message.success(this.$t('登录成功'));
							this.ti_type = false
							setTimeout(() => {
								this.$router.push({
									name: 'menu',
								});
							}, 1000)
						}else if(type == 3){ // 忘记密码
						    this.ti_type = false
						    this.qiehuan(7)
						}else if(type == 4){// 注册
							this.ti_type = false
							this.qiehuan(5)
						}
					}else{
						this.$message.error(res.msg);
						this.ti_type = false
						return
					}
				})
				
			},
			// 手机号验证码登录
			qiehuan(type){
				if(type == 1 || type == 2){
					this.deng_type = type
				}else if(type == 3){
					this.paw_type = !this.paw_type
					this.zhu_type = true
					this.wang_type = true
				}else if(type == 4){
					this.ce_type = this.ce_type == 1 ? 2 : 1
				}else if(type == 5){
					this.zhu_type = !this.zhu_type
					this.paw_type = true
					this.wang_type = true
				}else if(type == 6){
					this.zhao_type = this.zhao_type == 1 ? 2 : 1
				}else if(type == 7){
					this.wang_type = !this.wang_type
					this.paw_type = true 
					this.zhu_type = true
				}
				
				// this.phone=''
				this.email=''
				this.password = ''
				this.code = ''
				clearInterval(this.td);
				this.timTpe = false
				
			},
			huan(){
				let yuyan = this.$i18n.locale
				if(yuyan == 'zh'){
					this.$i18n.locale = 'en'
				}else{
					this.$i18n.locale = 'zh'
				}
				console.log(this.$i18n.locale,111111)
			},
			// 密码切换
			changeye(typeName, refName) {
				this.$set(
					this.pwdObj,
					`${typeName}`,
					this.pwdObj[`${typeName}`] === 'password' ? 'text' : 'password'
				)
				this.$refs[`${refName}`].focus()
			},
			//点击查看密码图标使光标定位到最后
			focusEnd(e) {
				//input获取光标显示在最后
				const obj = e.srcElement,
					// obj.focus()
					len = obj.value.length
				//光标定位要加上 setTimeOut，不然就会重新光标定位失败
				setTimeout(() => {
					obj.selectionStart = obj.selectionEnd = len
				}, 60)
			},
			
			
			
			
			encrypt(text) {
				let key = CryptoJS.enc.Utf8.parse('c81b7d38b57d7dbabcd3c38dc37446f4')
				let srcs = CryptoJS.enc.Utf8.parse(text)
				let encrypted = CryptoJS.AES.encrypt(srcs, key, {
					mode: CryptoJS.mode.ECB,
					padding: CryptoJS.pad.Pkcs7
				})
				return encrypted.toString()
			},
			getUUID() {
				const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
				return S4() + S4() + '' + S4() + '' + S4() + '' + S4() + '' + S4() + S4() + S4() + new Date().getTime()
			},
			getCaptchaData() {
				let device = ''
			
				let DEVICE_ID = ''
				if (window.sessionStorage.getItem('DEVICE_ID')) {
					DEVICE_ID = window.sessionStorage.getItem('DEVICE_ID')
				}
				// let DEVICE_ID = uni.getStorageSync('DEVICE_ID')
				if (!DEVICE_ID) {
					DEVICE_ID = this.getUUID()
					window.sessionStorage.setItem('DEVICE_ID', DEVICE_ID);
				}
				device = DEVICE_ID
				// 获取当前时间戳单位秒
				return this.encrypt(JSON.stringify({
					device,
					timestamp: Math.floor(new Date().getTime() / 1000)
				}))
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-input {
			height: 20px;
			width: 60%;
		}

		.el-input input {
			height: 20px;
			line-height: 20px;
			margin-top: -10px;
			background: rgba(0, 0, 0, 0);
			border: none;
		}

		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
			-webkit-appearance: none;
		}

		input[type="number"] {
			-moz-appearance: textfield;
		}
		.is-focus{
			.el-input__suffix{
				top: -11px !important;
			}
		}
		.el-input--suffix{
			.el-input__suffix{
				top: 10px;
			}
		}
		.elSelect{
			.el-input--suffix{
				width: 94px;
			}
			.el-input input{
				width: 94px;
				padding: 0 !important;
			}
		}
	}

	.container {
		width: 100%;
		height: 99.5vh;
		min-height: 900px;
		border: 0;
		position: relative;
	}

	.login_1 {
		width: 100%;
		height: 100%;
	}
	.login_2{
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		padding: 23px 0;
	}
	.login_2_1{
		// width: 111px;
		// height: 34px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		margin: 0 0 0 auto;
		padding: 8px 16px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.login_2_11{
		width: 16px;
		height: 16px;
		margin-right: 10px;
	}
	.login_3{
		top: 180px;
		left: 50%;
		transform: translateX(-50%);
	}
	.login_4_1{
		width: 229px;
		height: 72px;
		z-index: 2;
	}
	.login_4_2{
		width: 137px;
		height: 44px;
		background: #FFFFFF;
		right: 14px;
		top: -16px;
		z-index: 1;
	}
	.login_5{
		width: 600px;
		min-height: 500px;
		background: #FFFFFF;
		box-shadow: 0px 3px 6px 1px rgba(187,195,211,0.07);
		border-radius: 20px 20px 20px 20px;
		margin: 64px 0 0 0;
		padding: 0 0 32px 0 ;
	}
	.login_6{
		margin: 44px 0 0 0;
	}
	.login_6_1{
		width: 50%;
		
	}
	.login_6_2{
		width: 40px;
		height: 4px;
		background: #FF770F;
		border-radius: 50px 50px 50px 50px;
		margin: 10px 0 0 0;
	}
	.login_6_2s{
		width: 40px;
		height: 4px;
		// background: ;
		border-radius: 50px 50px 50px 50px;
		margin: 10px 0 0 0;
	}
	.login_6_3{
		font-weight: bold;
		font-size: 26px;
		color: #1A1A1A;
	}
	.login_6_3s{
		font-weight: bold;
		font-size: 26px;
		color: #999999;
	}
	.login_7{
		width: 440px;
		height: 48px;
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
		border: 1px solid #DADADA;
		margin: 32px auto 0;
		padding: 0 16px;
		box-sizing: border-box;
	}
	.login_7_1{
		width: 18px;
		height: 18px;
	}
	.login_7_2{
		// font-weight: bold;
		font-size: 16px;
		color: #1A1A1A;
		margin: 0 10px;
	}
	.login_7_3{
		width: 12px;
		height: 7px;
	}
	.login_7_4{
		width: 22px;
		height: 22px;
		margin-left: auto;
	}
	.login_8{
		width: 440px;
		margin: 12px auto 0;
	}
	.login_8_1{
		font-size: 14px;
		color: #333333;
	}
	.login_9{
		width: 440px;
		height: 48px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		margin: 46px auto 0;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		text-align: center;
		line-height: 48px;
	}
	.login_10{
		width: 440px;
		margin: 10px auto 0;
	}
	.login_11{
		width: 440px;
		margin: 50px auto 0;
	}
	.login_11_1{
		width: 16px;
		height: 16px;
	}
	.login_11_2{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: -4px 0 0 6px;
	}
	.index8 {
		height: 500px;
		overflow-y: auto;
	}
	.login_53{
		font-weight: 400;
		font-size: 16px;
		color: #FF770F;
	}
	.login_12{
		margin-top: 10px;
	}
	.login_13{
		color: #FF770F;
	}
	.login_14{
		padding: 24px 15px 0;
	}
	.login_14_1{
		width: 14px;
		height: 14px;
		
	}
	.login_14_2{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.login_14_3{
		font-weight: bold;
		font-size: 22px;
		color: #1A1A1A;
		left: 50%;
		transform: translateX(-50%);
	}
	.elSelect{
		width: 94px;
		margin: 0 0 0 10px;
	}
	.bind_1_1{
		width: 14px;
		height: 14px;
	}
	.bind_1_2{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-left: 10px;
	}
</style>